import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  WithholdingTaxTable,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import axios from "axios";
import { useForm } from "react-hook-form";
import { authHeader } from "../../../header";
import { AllowAccess } from "../../../components/BlockAccess";

export const WithholdingTaxManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    rate: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [WithholdingTaxes, setWithholdingTaxes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      rate: 0,
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const getAllWithholdingTaxes = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trwithholding-tax`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setWithholdingTaxes(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const createWithholdingTax = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/trwithholding-tax`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllWithholdingTaxes();
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
        message.success({
          content: "Tax Created Successfully",
          style: {
            marginTop: "20vh",
          },
        });
      }
      return { formData };
    } catch (error) {
      const err = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const editWithholdingTax = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/trwithholding-tax/${editId}`,
        obj,
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        getAllWithholdingTaxes();
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
        message.success({
          content: "Tax Updated Successfully",
          style: {
            marginTop: "20vh",
          },
        });
      }
      return { formData };
    } catch (error) {
      const err = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      resetForm();
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const onFormSubmit = () => {
    createWithholdingTax(formData);
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editWithholdingTax(formData);
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      rate: items.rate,
    });
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = WithholdingTaxes?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getAllWithholdingTaxes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="WithHolding Tax Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Withholding Tax</BlockTitle>
                {WithholdingTaxes.length < 1 ? (
                  <AllowAccess allowedRights={["CREATE_WITHHOLDING_TAX_RATE"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus" />
                      <span>Add Tax</span>
                    </Button>
                  </AllowAccess>
                ) : null}
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <WithholdingTaxTable
                WithholdingTax={currentItems}
                modal={modal}
                handleView={() => setModal({ view: true })}
                handleEdit={() => setModal({ edit: true })}
                onEditClick={onEditClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {WithholdingTaxes && WithholdingTaxes.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={WithholdingTaxes?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No withholding tax found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Add Tax</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Withholding Tax (%)</label>
                      <input
                        type="text"
                        name="rate"
                        // defaultValue={formData.rate}
                        placeholder="Withholding Tax"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.rate && <span className="invalid">{errors.rate.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Edit Withholding Tax</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Withholding Tax (%)</label>
                      <input
                        type="text"
                        name="rate"
                        defaultValue={formData.rate}
                        placeholder="Withholding Tax"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.rate && <span className="invalid">{errors.rate.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
